import { createTheme } from '@mui/material/styles';

const publicTheme = createTheme({
  typography: {
    fontFamily: '"Inter", sans-serif'
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          fontFamily: '"Inter", sans-serif'
        }
      }
    },

    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter", sans-serif'
        }
      }
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter", sans-serif'
        },
        input: {
          fontFamily: '"Inter", sans-serif'
        }
      }
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter", sans-serif'
        }
      }
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter", sans-serif'
        }
      }
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontFamily: '"Inter", sans-serif'
        }
      }
    }
  }
});

export default publicTheme;